/* Open the server-rendered guide before navigating to it. */
(() => {
  const openGuide = () => {
    if (window.location.hash !== '#collection-buying-guide') return;
    const guide = document.getElementById('collection-buying-guide');
    if (guide) guide.open = true;
  };
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-alp-guide-link]')) return;
    const guide = document.getElementById('collection-buying-guide');
    if (guide) guide.open = true;
  });
  window.addEventListener('hashchange', openGuide);
  openGuide();
})();
